import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AccountDetailsComponent } from './account-details/account-details.component';
import { AccountTabsComponent } from './account-tabs/account-tabs.component';
import { UserDetailsComponent } from '../user/user-details/user-details.component';
import { AccountSettingsComponent } from './account-settings/account-settings.component';
import { AuthGuard } from '../guards/auth.guard';
import { PlanGuard } from '../guards/plan.guard';
import { AppService } from '../app.service';
import {AccountTagsComponent} from "./account-tags/account-tags.component";
import { NotificationRolesComponent } from './notification-roles/notification-roles/notification-roles.component';
import { RbacRolesComponent } from './rbac-roles/rbac-roles/rbac-roles.component';
import { AccountDocsComponent } from './account-docs/account-docs/account-docs.component';
import { AccountDocsEditComponent } from './account-docs/account-docs-edit/account-docs-edit.component';
import { UserDocsComponent } from '../user/user-docs/user-docs.component';

const routes: Routes = [
  {
    path: 'account',
    component: AccountTabsComponent,
    canActivate: [
      AuthGuard
    ],
    children: [
      { path: 'settings', component: AccountSettingsComponent },
      { path: 'details', component: AccountDetailsComponent },
      // Account company documents are available on Free under their own plan feature. The template
      // and site document surfaces stay on the Premium DOCUMENTS feature.
      { path: 'folders', component: AccountDocsComponent, canActivate: [PlanGuard], data: { planFeature: AppService.FEATURES.COMPANY_DOCUMENTS } },
      { path: 'folders/:id/edit', component: AccountDocsEditComponent, canActivate: [PlanGuard], data: { planFeature: AppService.FEATURES.COMPANY_DOCUMENTS } },
      {
        // Personal user documents (own training/competency) are free/core and are NOT plan-gated.
        path: 'user',
        children: [
          { path: 'details', component: UserDetailsComponent },
          { path: 'folders', component: UserDocsComponent }
        ]
      },
      { path: 'rbac-roles', component: RbacRolesComponent },
      // Notification Roles is a Premium feature (mainly configures notifications for premium features).
      { path: 'notification-roles', component: NotificationRolesComponent, canActivate: [PlanGuard], data: { planFeature: AppService.FEATURES.NOTIFICATION_ROLES } },
      // Manage Tags is a Premium feature.
      { path: 'tags', component: AccountTagsComponent, canActivate: [PlanGuard], data: { planFeature: AppService.FEATURES.TAGS } }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AccountRoutingModule {}
